import { useIonToast, ToastOptions } from "@ionic/react";
import { OverlayEventDetail } from "@ionic/core";
import './Toast.css';

export const useAllieToast = useIonToast;
export type { ToastOptions, OverlayEventDetail };
